var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgUserIcon = function SvgUserIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h22v22H0z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 1.5a9.5 9.5 0 1 1 0 19 9.5 9.5 0 0 1 0-19zm0 14.314c-2.048 0-3.875.69-5.065 1.77H5.83A8.335 8.335 0 0 0 11 19.372a8.335 8.335 0 0 0 5.17-1.786h-.105c-1.19-1.08-3.017-1.77-5.065-1.77zM11 2.63a8.371 8.371 0 0 0-6.041 14.166C6.415 15.551 8.58 14.762 11 14.762c2.419 0 4.585.789 6.041 2.032A8.371 8.371 0 0 0 11 2.628zm0 3.745a3.814 3.814 0 1 1 0 7.627 3.814 3.814 0 0 1 0-7.627zm0 1.129a2.685 2.685 0 1 0 0 5.37 2.685 2.685 0 0 0 0-5.37z"
  })));
};

export default SvgUserIcon;